import type { EntityConfig } from '../types'

export const settlementEntity: EntityConfig = {
  id: 'settlement',
  displayName: 'Settlement',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'pending', label: 'Pending' },
      { value: 'in_transit', label: 'In Transit' },
      { value: 'paid', label: 'Paid' },
      { value: 'failed', label: 'Failed' }
    ],
    options: [
      { value: 'pending', label: 'Pending', color: 'pending' },
      { value: 'in_transit', label: 'In Transit', color: 'pending' },
      { value: 'paid', label: 'Paid', color: 'success' },
      { value: 'failed', label: 'Failed', color: 'error' }
    ],
    mappings: {
      all: ['pending', 'in_transit', 'paid', 'failed'],
      pending: ['pending'],
      in_transit: ['in_transit'],
      paid: ['paid'],
      failed: ['failed']
    }
  },
  queryFields: {},
  uiFilterFields: [
    'search',
    'status',
    'dateRange',
    'amount',
  ]
}
